/* Elle yazılmış, otuz satırlık DOM yardımcısı — React'in yerine geçen şey.

   Panelin yaptığı iş listeler ve formlar; ihtiyacı olan tek soyutlama
   "öznitelik ve çocuklarla eleman kur". Bunun için bir çerçeve getirmek,
   deponun geri kalanının hiç ödemediği bir bedel olurdu (build.mjs başlığı).

   `text` her zaman `textContent` ile yazılır, `innerHTML` ile değil. Panelde
   gösterilen metinlerin çoğu veritabanından geliyor ve bir kısmını stüdyo
   kendi yazıyor; birini bile ham HTML olarak basmak, panelin kendisini bir
   XSS yüzeyine çevirirdi. Ham HTML gerçekten gerektiğinde (günlük önizlemesi)
   o çağrı ayrıca ve adıyla yapılır. */

type Attrs = Record<string, string | number | boolean | null | undefined | EventListener>;
type Child = Node | string | null | undefined | false;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (value === null || value === undefined || value === false) continue;
    if (key.startsWith('on') && typeof value === 'function') {
      node.addEventListener(key.slice(2).toLowerCase(), value as EventListener);
    } else if (key === 'text') {
      node.textContent = String(value);
    } else if (value === true) {
      node.setAttribute(key, '');
    } else {
      node.setAttribute(key, String(value));
    }
  }
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    node.append(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return node;
}

/** Elemanın içeriğini tek seferde değiştirir. */
export function replace(host: Element, ...children: Child[]): void {
  host.replaceChildren(...children.filter((c): c is Node | string => Boolean(c)));
}

export function qs<T extends Element = HTMLElement>(selector: string, root: ParentNode = document): T {
  const found = root.querySelector<T>(selector);
  if (!found) throw new Error(`DOM: "${selector}" bulunamadı.`);
  return found;
}

/** Bayt sayısını okunur hâle getirir; tabloda hizalı dursun diye tam sayı. */
export function kb(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** ISO zaman damgasını panelde okunur biçime çevirir. */
export function when(iso: string | null | undefined): string {
  if (!iso) return '—';
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return '—';
  return at.toLocaleString('tr-TR', { dateStyle: 'medium', timeStyle: 'short' });
}
